<template>
    <div>
        <div class="custom-card">
            <div class="mt-8" style="position: relative">
                <center>
                    <img
                        class="br-12"
                        :src="reward.image"
                        :style="{
                            width: $device == 'mobile' ? '100%' : '50%',
                            margin: '0 auto',
                        }"
                    />
                </center>
                <!-- <img :src="reward.logo" style="width: 25%; margin: 0 auto; position: absolute; top: 8px; right: 8px" /> -->
            </div>
            <div class="row mt-16">
                <div class="col-12">
                    <div class="fs-20 fw-600 red">
                        {{ reward.brand }}
                    </div>
                </div>
            </div>
            <div class="mt-16 mb-16" style="background: #ffe6e6; border: 1px solid #ffb1b1; border-radius: 8px; height: 60px; display: flex; flex-direction: row; align-items: flex-start; padding: 16px; gap: 10px; flex: none; order: 2; flex-grow: 0">
                <label class="title fs-18 w-100"> {{ reward.title }} </label>
            </div>
            <div>
                <label class="detail fs-18 w-100" v-html="reward.plivilege"> </label>
            </div>
            <div class="mt-16 mb-16">
                <label class="detail fs-16 w-100">
                    ระยะเวลาการใช้คูปอง
                    {{ reward.start_date ? toMoment(reward.start_date) : '' }}-{{ reward.end_date ? toMoment(reward.end_date) : '' }}
                </label>
            </div>
            <div style="text-align: center; width: 100%; margin: 16px 0px 16px">
                <div style="width: 100%; border-radius: 8px; padding: 2px">
                    <div style="background: #fff; border-radius: 100px">
                        <!--  -->
                        <a-button
                            style="width: 50%"
                            size="large"
                            class="text-center br-20"
                            @click="step = 'เงื่อนไข'"
                            :style="{
                                'background-color': step == 'เงื่อนไข' ? '#CC0000' : '#FFFFFF',
                                'border-radius': '8px',
                                display: 'inline-block',
                            }"
                        >
                            <span
                                class="fs-20 fw-600"
                                :style="{
                                    color: step == 'เงื่อนไข' ? '#FFFFFF' : '#2e2f2e',
                                }"
                                >เงื่อนไข</span
                            >
                        </a-button>
                        <a-button
                            style="width: 50%"
                            size="large"
                            class="text-center br-20"
                            @click="step = 'สาขา'"
                            :style="{
                                'background-color': step == 'สาขา' ? '#CC0000' : '#FFFFFF',
                                'border-radius': '8px',
                                display: 'inline-block',
                            }"
                        >
                            <span
                                class="fs-20 fw-600"
                                :style="{
                                    color: step == 'สาขา' ? '#FFFFFF' : '#2e2f2e',
                                }"
                                >สาขา</span
                            >
                        </a-button>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <div v-if="step == 'เงื่อนไข'">
                    <label class="w-100 THSarabunNew fs-24 fw-300" v-html="reward.condition" />
                </div>
                <div v-else>
                    <label class="w-100 THSarabunNew fs-24 fw-300" v-html="reward.branch" />
                </div>
            </div>
            <!-- <div class="text-center mt-16">
                <a-button size="large" class="text-center primary-btn ant-button-label-custom fs-20" v-if="reward.display_button" @click="$router.replace({ path: '/use-reward', query: { reward } })">
                    <strong>ใช้คูปอง</strong>
                </a-button>
            </div> -->
            <div style="margin-bottom: 64px"></div>
            <div class="text-center" style="margin: 0; margin-top: 32px; padding-bottom: 20px; position: fixed; border-radius: 25px 25px 0 0; bottom: 0px; background-color: rgb(255, 255, 255); margin: -20px; width: 100%">
                <a-button size="large" class="text-center w-90 bg-red br-20" @click="$router.replace({ path: `/password/reward/${key}` })">
                    <span class="fs-20 color-white">ใช้คูปอง</span>
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
// import navbar from '../../components/navbar';
import moment from 'moment';
// import _ from 'lodash';
export default {
    components: {},
    data: function () {
        return {
            reward: {},
            step: 'เงื่อนไข',
            display_share_reward: false,
            share_reward_step: '1',
            modal_visible: false,
            modal_step: null,
            modal_data: {},
            key: this.$route.params.key,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        _mounted: function () {
            this.getRewardDetail(() => (this.getting_data = false));
        },
        getRewardDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/reward/share',
                    data: { key: this.key },
                    callback: (res) => {
                        if (res) {
                            this.reward = res;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(e, reward) {
            event.stopPropagation();
            var url;
            if (!reward.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: reward.priv_id,
                        type: 'reward',
                    },
                    callback: (res) => {
                        console.log('res', res);
                        if (res && res.result == 'complete') {
                            this.getReward();
                        } else {
                            const complete = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    complete.title += value[0];
                                }
                            }
                            this.$confirm({
                                title: complete.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                            console.log('complete.title', complete.title);
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
        toMoment(date_unix) {
            return this.mtby(moment.unix(date_unix), 'LL');
        },
    },
};
</script>
<style scoped>
.custom-card {
    margin: 8px;
    background-color: #fff;
    padding: 8px;
}
.title {
    font-weight: 600;
    margin: 0;
}
.detail {
    font-weight: 600;
    margin: 0;
    color: #000 !important;
}
.share-reward {
    position: fixed;
    bottom: 0;
    /* display: flex;
    flex-direction: row;
    align-items: flex-start; */
    padding: 12px 22px 40px;
    gap: 7%;
    background: #ffffff;
    box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.05);
    border-radius: 24px 24px 0px 0px;
    width: 100%;
    height: calc(100vh * 0.1479);
    z-index: 9999;
}
@media (max-device-width: 413px) {
    .time {
        font-size: 19px;
    }
    .custom-close {
        font-size: 15px;
    }
}
@media (max-device-width: 374px) {
    .time {
        font-size: 17px;
    }
    .custom-close {
        font-size: 13px;
    }
}
</style>